const PORTFOLIO_CONFIG = {
  player: {
    speed: 1.5,
    gravity: 0.2,
    jumpVelocity: -3.5,
    width: 10,
    height: 14,
  },
  world: {
    width: 1050,
    groundY: 128,
    tileSize: 8,
    endZoneX: 950,
  },
  camera: {
    playerOffset: 50,
  },
  screen: {
    width: 160,
    height: 144,
  },
};

export { PORTFOLIO_CONFIG };
